import Lottie from 'lottie-react';
import styled from 'styled-components';

/**
 * This wrapper should not be used with customer-supplied Lottie assets.
 *
 * Some animations have fills or strokes that shouldn't change with theme.
 * These should be given the class .no-theme.
 *
 * The style rules here differ slightly from ThemedSvg. The special classnames
 * applied to parent `g` tags and cascade. This is to better support classnames
 * generated from Adobe AfterEffects, which are attached to groups instead of the
 * individual vectors themselves.
 *
 * TODO: This should NOT fall back to `theme`. Remove once SST supports proper
 * server-driven fallbacks.
 */
const ThemedLottie = styled(Lottie)<{
  $primaryColor?: string;
  $highlightColor?: string;
  $backgroundColor?: string;
  $strokeColor?: string;
}>`
  circle[stroke]:not(.no-theme),
  rect[stroke]:not(.no-theme),
  path[stroke]:not(.no-theme),
  g[stroke]:not(.no-theme),
  g:not(.no-theme) circle[stroke],
  g:not(.no-theme) rect[stroke],
  g:not(.no-theme) path[stroke] {
    stroke: ${({ $strokeColor, theme }) => $strokeColor ?? theme.iconColorStroke};
  }

  circle[fill]:not([fill='none']):not(.no-theme),
  rect[fill]:not([fill='none']):not(.no-theme),
  path[fill]:not([fill='none']):not(.no-theme),
  g[fill]:not([fill='none']):not(.no-theme),
  g:not(.no-theme) circle[fill],
  g:not(.no-theme) rect[fill],
  g:not(.no-theme) path[fill] {
    fill: ${({ $primaryColor, theme }) => $primaryColor ?? theme.iconColorPrimary};
  }

  circle[fill].icon-color-highlight,
  rect[fill].icon-color-highlight,
  path[fill].icon-color-highlight,
  g[fill].icon-color-highlight,
  g.icon-color-highlight circle[fill],
  g.icon-color-highlight rect[fill],
  g.icon-color-highlight path[fill] {
    fill: ${({ $highlightColor, theme }) => $highlightColor ?? theme.iconColorHighlight} !important;
  }

  circle[fill].icon-color-background,
  rect[fill].icon-color-background,
  path[fill].icon-color-background,
  g[fill].icon-color-background,
  g.icon-color-background circle[fill],
  g.icon-color-background rect[fill],
  g.icon-color-background path[fill] {
    fill: ${({ $backgroundColor, theme }) =>
      $backgroundColor ?? theme.iconColorBackground} !important;
  }

  circle[fill].icon-color-stroke,
  rect[fill].icon-color-stroke,
  path[fill].icon-color-stroke,
  g[fill].icon-color-stroke,
  g.icon-color-stroke circle[fill],
  g.icon-color-stroke rect[fill],
  g.icon-color-stroke path[fill] {
    fill: ${({ $strokeColor, theme }) => $strokeColor ?? theme.iconColorStroke} !important;
  }

  /* Stop SVGs from taking up more vertical space than they should in flex layouts */
  line-height: 0;
`;

export default ThemedLottie;
